import { type FC, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "../lib/auth/AuthContext";
import { queryClient } from "../shared/utils/TanstackQueryClient";

interface ProviderProp {
  children: ReactNode;
}
const AppProviders: FC<ProviderProp> = ({ children }): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* <ContextPovider>{children}</ContextPovider> */}
        {/* <GlobalProvider></GlobalProvider> */}
        {children}
      </AuthProvider>
    </QueryClientProvider>
  );
};
export default AppProviders;
